import { jsx as t } from "react/jsx-runtime";
import { S as c } from "./chunks/index.CCavb-1K.js";
import "@smart/web-foundations";
import h from "react";
import { u as i, T as n } from "./chunks/theme-context.BfIZgriR.js";
import './assets/theme.css';const d = "_light_ske5x_2", l = "_dark_ske5x_40", T = {
  light: d,
  dark: l
}, _ = h.forwardRef(
  ({ theme: r, asChild: o, children: s }, m) => {
    const { theme: a } = i(), e = r ?? a;
    return /* @__PURE__ */ t(n, { theme: e, children: /* @__PURE__ */ t(o ? c : "div", { className: T[e], ref: m, children: s }) });
  }
);
_.displayName = "Theme";
export {
  _ as Theme
};
//# sourceMappingURL=theme.js.map
